<template>
  <div class="subscription-required">
    <KeyIcon class="subscription-required__icon" />
    <p class="subscription-required__notice">
      Get Access to this Content with an INE Subscription
    </p>
    <a :href="`//${plansLink}`" class="btn btn--primary">Get Started</a>
  </div>
</template>

<script>
import KeyIcon from '@/assets/icons/course/key_icon.svg'

export default {
  name: 'SubscriptionRequired',
  components: {
    KeyIcon: { ...KeyIcon, name: 'KeyIcon' },
  },
  props: {
    plansLink: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.subscription-required {
  display: flex;
  align-items: center;
  &__notice {
    font-size: 14px;
    color: var(--white);
    margin: 0 15px 0 0;
    font-family: var(--font-bold);
  }
  &__icon {
    margin: 0 15px 0 0;
  }
}
</style>
